import { Button, Trash } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { styled } from 'styled-components'

type DeleteButtonProps = {
  onClick: () => void
  children?: string
  testId?: string
  isDisabled?: boolean
}

export const DeleteButton = ({
  onClick,
  children,
  testId,
  isDisabled = false
}: DeleteButtonProps) => {
  return (
    <StyledButton onClick={onClick} disabled={isDisabled} data-testid={testId}>
      <Trash />
      <Text weight="medium">{children}</Text>
    </StyledButton>
  )
}

const StyledButton = styled(Button)`
  padding: 0;
  border: none;
  background: none;
  color: ${(props) => props.theme.color.neutral.color4};
`
